export interface CookieSettingsType {
  strictlyNecessary: boolean
  performance: boolean
  functional: boolean
  targeting: boolean
}

export interface CookieConsentType {
  isSet: boolean
  settings: CookieSettingsType
  timestamp: number
}

export const ACCEPT_ALL_SETTINGS: CookieSettingsType = {
  strictlyNecessary: true,
  performance: true,
  functional: true,
  targeting: true,
}

export const REJECT_ALL_SETTINGS: CookieSettingsType = {
  strictlyNecessary: true,
  performance: false,
  functional: false,
  targeting: false,
}

export const DEFAULT_COOKIE_SETTINGS: CookieSettingsType = REJECT_ALL_SETTINGS
